import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Renderer2, Input, OnInit, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ToastrService } from "ngx-toastr";
import { invoiceFilter } from "../../common-functions";

import { DatePipe } from '@angular/common';
import { TitleCasePipe } from '@angular/common';
import * as saveAs from 'file-saver';
import { SignaturePad } from 'angular2-signaturepad';
import { Observable, ReplaySubject, Subject, ignoreElements } from 'rxjs';
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { JsonPipe, KeyValue } from '@angular/common';
import { HeaderComponent } from './../../layouts/header/header.component';
import { SharedService } from './../../services/sharedService/shared.service'
import { PDFDocument } from 'pdf-lib'
// import { PhoneFormatPipe } from 'src/app/pipes/phone-format.pipe';
import { PhoneFormatPipe } from "../../pipes/phone-format.pipe";
// import { Modal } from 'bootstrap';
import { LoaderService } from 'src/app/loader.service';
import { ConfirmationDialogComponent } from './../confirmation-dialog/confirmation-dialog.component';
import { floatWith2Decimals, groupBy, sumBy, adjustWith2DecimalsForUI } from "../../common-functions";


import { state } from '@angular/animations';
// import { MaskNumberPipe } from '../pipes/mask-number.pipe';
import SwiperCore, { Navigation, EffectCoverflow, Pagination, SwiperOptions, Swiper, Virtual } from "swiper";
import {

  SafeResourceUrl,

  DomSanitizer,

  SafeHtml,

  SafeUrl,

  SafeStyle,

  SafeScript,

  EventManager,

} from "@angular/platform-browser";
import jsPDF from 'jspdf';
import { type } from 'jquery';
// import { moment } from 'ngx-bootstrap/chronos/testing/chain';

import * as moment from "moment";
import { DecimalPipe, } from "@angular/common";
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { CommonPatternsService } from 'src/app/common-patterns.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CustomDatePipe } from 'src/app/pipes/customdate.pipe';
import { GlobalStoreService } from 'src/app/services/global-store.service';
import { Config } from 'datatables.net';

@Component({
  selector: 'app-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.css']
})
export class MarketingComponent implements OnInit {
  accessToken: any;
  broucherPdfFile: any
  broucherList: any = []
  // dtOptions: DataTables.Settings = {};
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
    destroy: true,
  };
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(
    private http: HttpClient, private router: Router, private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // this.dtOptions = {
    //   pagingType: 'simple_numbers',
    //   order: [],
    //   language: {
    //     searchPlaceholder: 'Search here...'
    //   },
    //   destroy: true,
    //   // ordering: true,
    //   // columnDefs: [
    //   //   {
    //   //     targets: '_all', // Index of the 'id' column
    //   //     orderable: false, // Disable sorting for this column
    //   //   },
    //   // ],
    // };
    this.accessToken = sessionStorage.getItem('accessToken');
    this.getBrouchers()
  }



  getBrouchers() {

    let endPoint = '/common/brochures'

    this.http.get(environment.apiUrl + '/api/ap' + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {
        this.broucherList = response.data
        // Swal.fire({ allowOutsideClick: false, title: "Info", text: response.message });

      } else {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
      }
    },
      (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: "Info",
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: "Proceed",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: "Error", text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      })
  }
  showBroucherFile(brochure: any) {
    this.broucherPdfFile = brochure.fileName
    const encodedUrl = encodeURI(brochure.fileName);
    this.broucherPdfFile = encodedUrl
    // setTimeout(() => {
    //   this.broucherPdfFile = "https://testapi.groupbenefitz.aitestpro.com/app/server/en/terms-conditions-en.pdf";
    //   // this.broucherPdfFile = this.sanitizer.bypassSecurityTrustResourceUrl(encodedUrl);

    console.log(this.broucherPdfFile)
    // }, 3000);


  }
  downloadBroucher(brocuher: any) {
    this.http.get(brocuher.fileName, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = brocuher.name + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: error.error.error.message })
      }
    );

  }
}
